import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultLabel: {
    id: 'dropdown.default-label',
    defaultMessage: 'Dropdown menu',
  },
  defaultActiveDescendantMessage: {
    id: 'dropdown.default-message',
    defaultMessage: 'No information available',
  },
  noMatch: {
    id: 'dropdown.no-match',
    defaultMessage: 'No matching options',
  },
  selectAll: {
    id: 'dropdown.select-all',
    defaultMessage: 'Select all',
  },
});

export default messages;
